import React, { FC, useEffect, useState } from 'react';
import { config } from 'config/config';
import { Button, Checkbox, Col, Modal, Row } from 'antd';
import { staticRoutes } from 'config/routes';
import { useIntl } from 'react-intl';
import CustomModal from 'src/components/CustomModal';
import { customFormatMessage } from 'utils';

interface Props {
  email: string;
  setTermsAccepted: React.Dispatch<React.SetStateAction<boolean>>;
  termsAccepted: null | boolean;
  redirect?: boolean;
  password: string;
  rememberMe: boolean;
  login: ({
    email,
    password,
    rememberMe,
    validateTerms,
    redirect,
  }: {
    email: string;
    password: string;
    rememberMe?: boolean;
    validateTerms?: boolean;
    redirect?: boolean;
  }) => (dispatch: any) => Promise<boolean>;
}

const ValidateTermsModal: FC<Props> = ({
  email,
  login,
  password,
  rememberMe,
  setTermsAccepted,
  termsAccepted,
  redirect = true,
}) => {
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [error, setError] = useState(null);
  const [checked, setChecked] = useState(false);
  const [checkedNewsletter, setCheckedNewsletter] = useState(false);
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (!modalVisible && termsAccepted === false) setModalVisible(true);
  }, [termsAccepted]);

  const handleCloseModal = () => {
    setTermsAccepted(null);
    setModalVisible(false);
    setError(null);
    setChecked(false);
  };

  const handleValidate = async () => {
    try {
      setLoading(true);
      await login({
        email,
        password,
        rememberMe,
        validateTerms: true,
        redirect,
      });
      handleCloseModal();
    } catch (err) {
      console.log('Validate terms error', err);
      setError(err.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  return(
    <Modal
      visible={modalVisible}
      closable={false}
      keyboard={false}
      footer={null}
      className='terms-conditions-modal'
      >
      <Row justify='center'>
        <Row justify='center'>
          <div style={{display: 'flex', margin: '0px aut0'}}>
            <h3 className='terms-conditions-title'>
              {customFormatMessage('terms-and-conditions.title', {
                  terms: (chunks: any) => (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`static?page=${staticRoutes.FOOTER.TERMS}`}
                      className="link underline-text"
                    >
                      {chunks}
                    </a>
                  ),
              })}
            </h3>
          </div>
        </Row>
        <Row justify='center'>
          <div style={{display: 'flex', margin: '0px aut0'}}>
            <p className='terms-conditions-subtitle'>
              {customFormatMessage('terms-and-conditions.subtitle-one')}
            </p>
          </div>
        </Row>
        <Button className='terms-conditions-button' onClick={handleValidate}>
          <p className='terms-conditions-text-button'>
            {customFormatMessage('terms-and-conditions.button')}
          </p>
        </Button>
      </Row>
  </Modal>
  );
};

export default ValidateTermsModal;
